// 在 SPA 中安全注入 JSON-LD 结构化数据
export default function JsonLd({ data }: { data: object }) {
  const json = JSON.stringify(data);
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: json }}
    />
  );
}